import { render, staticRenderFns } from "./UnScoredIcon.vue?vue&type=template&id=11b339a3&scoped=true&"
var script = {}
import style0 from "./UnScoredIcon.vue?vue&type=style&index=0&id=11b339a3&prod&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b339a3",
  null
  
)

export default component.exports